export { PatientsTodayWidget } from './patients-today.widget.tsx';
export { StatsWidget } from './stats.widget.tsx';
export { MessagesWidget } from './messages.widget.tsx';
export { ActivityWidget } from './activity.widget.tsx';
export { FirstContactWidget } from './first-contact.widget.tsx';
export { TasksWidget } from './tasks.widget.tsx';
export { PatientRdvWidget } from './patient-rdv.widget.tsx';
export { PatientNotesWidget } from './patient-notes.widget.tsx';
export { PatientTimelineWidget } from './patient-timeline.widget.tsx';
export { CurrentPatientWidget } from './current-patient.widget.tsx';
export { ClinicalCommentsWidget } from './clinical-comments.widget.tsx';
export { DiagnosticWidget } from './diagnostic.widget.tsx';
export { TreatmentPlanWidget } from './treatment-plan.widget.tsx';
export { ObjectivesWidget } from './objectives.widget.tsx';
export { PatientFilesWidget } from './patient-files.widget.tsx';
export { MediaViewerWidget } from './media-viewer.widget.tsx';
export { PatientChatWidget } from './patient-chat.widget.tsx';
export { PatientsTodayGridWidget } from './patients-today-grid.widget.tsx';
export { TasksGridWidget } from './tasks-grid.widget.tsx';
export { MessagesGridWidget } from './messages-grid.widget.tsx';
export { FirstContactGridWidget } from './first-contact-grid.widget.tsx';
export { PatientRdvGridWidget } from './patient-rdv-grid.widget.tsx';
export { ClinicalCommentsGridWidget } from './clinical-comments-grid.widget.tsx';
export { PatientCivilWidget } from './patient-civil.widget.tsx';
export { PatientBillingWidget } from './patient-billing.widget.tsx';
export { PatientHistoryWidget } from './patient-history.widget.tsx';
export { AgendaWidget } from './agenda.widget.tsx';

import { PatientsTodayWidget } from './patients-today.widget.tsx';
import { StatsWidget } from './stats.widget.tsx';
import { MessagesWidget } from './messages.widget.tsx';
import { ActivityWidget } from './activity.widget.tsx';
import { FirstContactWidget } from './first-contact.widget.tsx';
import { TasksWidget } from './tasks.widget.tsx';
import { PatientRdvWidget } from './patient-rdv.widget.tsx';
import { PatientNotesWidget } from './patient-notes.widget.tsx';
import { PatientTimelineWidget } from './patient-timeline.widget.tsx';
import { CurrentPatientWidget } from './current-patient.widget.tsx';
import { ClinicalCommentsWidget } from './clinical-comments.widget.tsx';
import { DiagnosticWidget } from './diagnostic.widget.tsx';
import { TreatmentPlanWidget } from './treatment-plan.widget.tsx';
import { ObjectivesWidget } from './objectives.widget.tsx';
import { PatientFilesWidget } from './patient-files.widget.tsx';
import { MediaViewerWidget } from './media-viewer.widget.tsx';
import { PatientChatWidget } from './patient-chat.widget.tsx';
import { PatientsTodayGridWidget } from './patients-today-grid.widget.tsx';
import { TasksGridWidget } from './tasks-grid.widget.tsx';
import { MessagesGridWidget } from './messages-grid.widget.tsx';
import { FirstContactGridWidget } from './first-contact-grid.widget.tsx';
import { PatientRdvGridWidget } from './patient-rdv-grid.widget.tsx';
import { ClinicalCommentsGridWidget } from './clinical-comments-grid.widget.tsx';
import { PatientCivilWidget } from './patient-civil.widget.tsx';
import { PatientBillingWidget } from './patient-billing.widget.tsx';
import { PatientHistoryWidget } from './patient-history.widget.tsx';
import { AgendaWidget } from './agenda.widget.tsx';

export const Widgets = {
  PatientsTodayWidget,
  StatsWidget,
  MessagesWidget,
  ActivityWidget,
  FirstContactWidget,
  TasksWidget,
  PatientRdvWidget,
  PatientNotesWidget,
  PatientTimelineWidget,
  CurrentPatientWidget,
  ClinicalCommentsWidget,
  DiagnosticWidget,
  TreatmentPlanWidget,
  ObjectivesWidget,
  PatientFilesWidget,
  MediaViewerWidget,
  PatientChatWidget,
  PatientsTodayGridWidget,
  TasksGridWidget,
  MessagesGridWidget,
  FirstContactGridWidget,
  PatientRdvGridWidget,
  ClinicalCommentsGridWidget,
  PatientCivilWidget,
  PatientBillingWidget,
  PatientHistoryWidget,
  AgendaWidget,
};
